module.exports = __webpack_public_path__ + "static/media/may.1473d307.png";